export const locale = {
    lang: 'pl',
    data: {
        'Dashboard': 'Pulpit',
        'Trainer dashboard': 'Pulpit',
        'Start date': 'Data rozpoczęcia',
        'End date': 'Data zakończenia',
        'Participants quantity': 'Ilość uczestników',
        'Details': 'Szczegóły',
        'No upcoming classes found': 'Nie znaleziono nadchodzących zajęć',
        'Go to activity': 'Przejdź do zajęć',
    }
};
